<div class="content-wrapper p-0 my-application-outer-container">
	<app-content-header [contentHeader]="contentHeader"></app-content-header>
	<div class="content-body">
		<!-- app e-commerce details start -->
		<app-euttc-application-list [fromPageType]="applicationList"></app-euttc-application-list>
	</div>
</div>
